// extracted by mini-css-extract-plugin
export default {"wrapper":"CookieNotice_wrapper__2ovyL","actions":"CookieNotice_actions__JWgRu"};